/* eslint-disable @typescript-eslint/no-explicit-any */
import { CouponOutput } from '@/api/gql/graphql';
import { FormMode } from '@/pages/Coupons/coupons.hook';
import { create } from 'zustand';

type CouponStore = {
  formMode: FormMode;
  setFormMode: (mode: FormMode) => void;
  couponId: string | '';
  setCouponId: (id: string | '') => void;
  coupon: any | null;
  setCoupon: (coupon: CouponOutput | null) => void;
  couponListLimit: number;
  setCouponListLimit: (limit: number) => void;
  couponListPage: number;
  setCouponListPage: (page: number) => void;
  currentPageTitle?: string;
  isOpenCouponFormModal: boolean;
  setCurrentPageTitle?: (currentPage: string) => void;
  openCouponFormModal: () => void;
};
export const useCouponStore = create<CouponStore>()((set) => ({
  coupon: null,
  setCoupon: (coupon) => set({ coupon }),
  formMode: 'create',
  setFormMode: (mode) => set({ formMode: mode }),
  couponListPage: 1,
  couponListLimit: 10,
  couponId: '',
  packageId: '',
  setCouponId: (id) => set({ couponId: id }),
  setCouponListPage: (couponListPage) => set({ couponListPage }),
  currentPageTitle: 'Les Offres',
  isOpenCouponFormModal: false,
  isOpenPackageFormModal: false,
  setCurrentPageTitle: (currentPageTitle) => set({ currentPageTitle }),
  openCouponFormModal: () =>
    set((state) => ({
      isOpenCouponFormModal: !state.isOpenCouponFormModal,
    })),
  setCouponListLimit: (couponListLimit) => set({ couponListLimit }),
}));
